import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { reduxForm, Field, Form } from 'redux-form/immutable';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { getDialogContextValue } from '../../../../redux/selectors';

import styles from './styles';
import { showDialog, hideDialog } from '../../../../redux/actions/dialogs';
import ReduxDialog from '../../../Common/ReduxDialog';
import { required } from '../../../../utils/formvalidation';
import { renderJobProfileQualityControlQuestions, renderSelect, renderTextField } from '../../../../utils/reduxforms';
import { uuid } from '../../../../utils/helper';
import { STAGE_DIALOG } from '../../../../redux/constants/dialogs';

// const STAGE_TYPES = [
//   {
//     //   id: 'Basic',
//     //   name: 'Basic',
//     //   description: 'Basic',
//     // }, {
//     id: 'AddItems',
//     name: 'Add Items',
//     description: 'Add items to a task',
//   }, {
//     id: 'VerifyItems',
//     name: 'Verify Items',
//     description: 'Verify items are present',
//   },
// ];

const RELATIVE_TO_LOCATIONS = [
  'origin',
  'destination',
];

// const renderType = (type) => {
//   return (<div style={styles.type}>
//     <div style={styles.typeName}>{type.name}</div>
//     <div style={styles.typeDesc}>{type.description}</div>
//   </div>);
// };

class StageDialog extends Component {
  render() {
    const { handleSubmit, initialValues, submit, hideDialog, showDialog } = this.props;

    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={() => hideDialog(STAGE_DIALOG)}
      >Cancel</Button>,
      <Button
        key="save"
        variant="contained"
        color="primary"
        autoFocus
        onClick={() => submit('Stage')}
      >Save</Button>,
    ];

    return (
      <div>
        <ReduxDialog
          name={STAGE_DIALOG}
          title={initialValues && initialValues.get('name') ? initialValues.get('name') : 'Add Stage'}
          subTitle={'A task is comprised of one to many stages. Each stage represents a unique piece of work to be done by a specific team member.'}
          actions={actions}
          modal
          autoScrollBodyContent
          onRequestClose={this.handleCancel}
          contentStyle={styles.body}
          fullWidth
          maxWidth="sm"
        >
          <Form name="Stage" onSubmit={handleSubmit} style={styles.form}>
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <Field
                  name="name"
                  component={renderTextField}
                  label="Name"
                  fullWidth
                  validate={required}
                />
              </Grid>
              {/*<Grid item xs={12}>*/}
              {/*<Field*/}
              {/*name="type"*/}
              {/*component={renderSelect}*/}
              {/*label="Type"*/}
              {/*fullWidth*/}
              {/*validate={required}>*/}
              {/*{STAGE_TYPES.map((type) => <MenuItem*/}
              {/*key={type.id}*/}
              {/*value={type.id}*/}
              {/*style={styles.iconItem}*/}
              {/*label={type.name}*/}
              {/*>{renderType(type)}</MenuItem>)}*/}
              {/*</Field>*/}
              {/*</Grid>*/}
              <Grid item xs={12}>
                <Field
                  name="relativeTo"
                  component={renderSelect}
                  label="Location Relative To"
                  fullWidth
                  validate={required}>
                  {RELATIVE_TO_LOCATIONS.map((location) => <MenuItem
                    key={location}
                    value={location}
                    label={location}
                  >{location}</MenuItem>)}
                </Field>
              </Grid>

              <Grid item xs={12}>
                <Field
                  name="qa.questions"
                  component={renderJobProfileQualityControlQuestions}
                  fullWidth
                  showDialog={showDialog}
                  hideDialog={hideDialog}
                />
              </Grid>
            </Grid>
          </Form>
        </ReduxDialog>

      </div>
    );
  }
}

StageDialog.propTypes = {
  stage: PropTypes.object,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,

  onSave: PropTypes.func.isRequired,
};

const form = reduxForm({
  form: STAGE_DIALOG,  // a unique identifier for this form
  onSubmit: (values, dispatch, props) => {
    const stage = values.toJS();
    return props.onSave(stage);
  },
  onSubmitSuccess: (result, dispatch, props) => {
    props.hideDialog(STAGE_DIALOG);
  },
})(StageDialog);

function mapStateToProps(state) {
  const initialValues = getDialogContextValue(state)(STAGE_DIALOG, 'stage') || new Map();
  return {
    initialValues: initialValues.update('id', (val) => val || uuid()),
    onSave: getDialogContextValue(state)(STAGE_DIALOG, 'onSave'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Admin/JobProfiles/StageDialog/index.js